import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  Form,
  FormGroup,
  Input,
  Button,
  Spinner,
  Container,
  Breadcrumb,
  BreadcrumbItem,
} from "reactstrap";
// import background from "../../assets/background.png";
import { toast } from "react-toastify";
import "./authentication.scss";
import eyeshow from "../../assets/eyeshow.svg";
import eyehide from "../../assets/eyehide.svg";
import { authReset } from "../../Shared/validation";
import { resetPassword } from "../../services/auth.service";
import Footer from "../../layout/Footer";
import { GoHome } from "react-icons/go";
import { MdOutlineNavigateNext } from "react-icons/md";
import AuthBanner from "../../assets/auth_banner.png";

function ResetPassword() {
  const [passwordType, setPasswordType] = useState("password");
  const [cnfPasswordType, setCnfPasswordType] = useState("password");
  const [errors, setErrors] = useState({});
  const [passwordRequirement, setPasswordRequirement] = useState("");
  const [values, setValues] = useState({
    password: "",
    confirmPassword: "",
  });
  const [LoginClick, setLoginClick] = useState(false);
  const navigate = useNavigate();
  const search = useLocation()?.search;
  const guid = new URLSearchParams(search)?.get("guid");
  const userName = new URLSearchParams(search)?.get("userName");

  var regex =
    /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;

  useEffect(() => {
    setTimeout(() => {
      window?.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  }, []);

  const handleChange = (e) => {
    const newData = { ...values };
    const minlength = 8;
    const requireUpperCase = true;
    const requireLowerCase = true;
    const requireNumbers = true;
    // const requireSpecialCharters = true;
    const forbiddenWords = [
      "password",
      "123456",
      "123",
      "12345",
      "123456789",
      "12345678",
      "qwerty",
      "test",
      "hello",
      "abc",
      "xyz",
    ];

    if (e.target.id === "password") {
      console.log(e.target.value);
      if (e.target.value.length < minlength) {
        setPasswordRequirement(
          "Please make sure the min length of the password is 8 letters."
        );
      } else if (requireUpperCase && !/[A-Z]/.test(e.target.value)) {
        setPasswordRequirement(
          "Password must container a UpperCase or Capital letter"
        );
      } else if (requireLowerCase && !/[a-z]/.test(e.target.value)) {
        setPasswordRequirement(
          "Password must contain a lowerCase or small letter"
        );
      } else if (requireNumbers && !/\d/.test(e.target.value)) {
        setPasswordRequirement("Password must contain Numbers");
      }
      //  else if (
      //   requireSpecialCharters &&
      //   !/[!@#$%^&*(),.?":{}|<>/]/.test(e.target.value)
      // ) {
      //   setPasswordRequirement("Password must contain a special characters");
      // }
      else if (
        forbiddenWords.some((word) =>
          e.target.value.toLowerCase().includes(word)
        )
      ) {
        setPasswordRequirement("Password must be strong");
      } else {
        setPasswordRequirement("");
      }
    }
    newData[e?.target?.id] = e?.target?.value?.trim()?.replace(regex, "");
    errors[e?.target?.id] = null;
    setValues(newData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = await authReset(values);
    setErrors(errors);
    if (errors === null) {
      setErrors({});
      setLoginClick(true);
      try {
        const response = await resetPassword(
          {},
          {
            userName: userName,
            password: values?.password,
            guid: guid,
          }
        );
        if (response.status === 200) {
          toast.success("Password changed successfully!", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          setTimeout(() => {
            navigate("/sign-in");
          }, 2000);
        } else {
          toast.error("Invalid Password", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          setLoginClick(false);
        }
      } catch (err) {
        let error_message = "Invalid Password";
        if (
          err?.response &&
          err?.response?.data &&
          err?.response?.data?.message
        ) {
          error_message = err?.response?.data?.message;
        }
        toast.error(error_message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
        setLoginClick(false);
      }
    }
  };

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  const toggleCnfPassword = () => {
    if (cnfPasswordType === "password") {
      setCnfPasswordType("text");
      return;
    }
    setCnfPasswordType("password");
  };

  const isDiasabled = () => {
    if (LoginClick === true) {
      return true;
    }
  };

  return (
    <section>
      <Container>
        <Breadcrumb className="nt-breadcrumb">
          <Link to="/" className="breadcrumb_item1">
            <GoHome className="home_icon" />
          </Link>
          <span className="breadcrumb-divider">
            <MdOutlineNavigateNext />
          </span>
          <BreadcrumbItem active>
            <Link to="/forgot-password" className="nt-breadcrumb_item2">
              Reset Password
            </Link>
          </BreadcrumbItem>
        </Breadcrumb>
        <div className="signin_section resetpassword">
          <div className="Leftsection">
            <img src={AuthBanner} alt="" />
          </div>
          <div className="Rightsection">
            <Form onSubmit={handleSubmit} className="signinform">
              <h3>Reset Password</h3>
              <span>Please enter a new password to change</span>
              {/* <div className="warning">
                <span>
                  Please create a strong password. Ensure that your password is
                  at least 8 characters long and includes a lowercase letter, an
                  uppercase letter, a number, and a special character like (! @
                  # $ % & *)
                </span>
              </div> */}
              <div className="form_section resetpassword">
                <FormGroup style={{ marginTop: "20px" }}>
                  <div className="password">
                    <Input
                      id="password"
                      name="password"
                      autoComplete="off"
                      value={values?.password}
                      onChange={handleChange}
                      placeholder="New Password"
                      type={passwordType}
                    />
                    <Button onClick={togglePassword}>
                      {passwordType === "password" ? (
                        <img src={eyeshow} alt="show" />
                      ) : (
                        <img src={eyehide} alt="hide" />
                      )}
                    </Button>
                  </div>
                  <span className="error">
                    {errors?.password && errors?.password}
                  </span>
                </FormGroup>
                <FormGroup>
                  <div className="password">
                    <Input
                      id="confirmPassword"
                      name="confirmPassword"
                      autoComplete="off"
                      value={values?.confirmPassword}
                      onChange={handleChange}
                      placeholder="Confirm Password"
                      type={cnfPasswordType}
                    />
                    <Button onClick={toggleCnfPassword}>
                      {cnfPasswordType === "password" ? (
                        <img src={eyeshow} alt="show" />
                      ) : (
                        <img src={eyehide} alt="hide" />
                      )}
                    </Button>
                  </div>
                  <span className="error">
                    {errors?.confirmPassword && errors?.confirmPassword}
                  </span>
                </FormGroup>
                <span className="error">
                  {passwordRequirement && passwordRequirement}
                </span>
                <Button type="submit" disabled={isDiasabled()}>
                  {LoginClick === true ? (
                    <Spinner size="sm"></Spinner>
                  ) : (
                    "Change Password"
                  )}
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </Container>
      <Footer />
    </section>
  );
}

export default ResetPassword;
